import React from 'react';
export function Footer() {
  return <footer className="bg-[#2B2724] text-white py-8 md:py-12 px-4" data-id="element-116">
      <div className="max-w-7xl mx-auto text-center" data-id="element-117">
        <div className="mb-4 md:mb-6" data-id="element-118">
          <h2 className="text-xl md:text-2xl font-bold mb-2" data-id="element-119">
            🪵 MEGAPACK MUEBLES JAPANDI™
          </h2>
          <p className="text-xs md:text-sm text-white/70 max-w-3xl mx-auto leading-relaxed" data-id="element-120">
            El sistema de fabricación y negocio N°1 para artesanos Japandi en
            Argentina. Porque fabricar muebles de diseño que se venden caro no
            debería costarte años de prueba y error.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4 mb-4 md:mb-6 text-xs md:text-sm" data-id="element-121">
          <a href="mailto:contacto@infinitosaber.com" className="text-white/80 hover:text-[#C2613A] transition-colors" data-id="element-122">
            contacto@infinitosaber.com
          </a>
          <span className="hidden md:inline text-white/40" data-id="element-123">·</span>
          <a href="https://instagram.com/infinitosaber" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#C2613A] transition-colors" data-id="element-124">
            @infinitosaber
          </a>
          <span className="hidden md:inline text-white/40" data-id="element-125">·</span>
          <a href="https://infinitosaber.com" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#C2613A] transition-colors" data-id="element-126">
            infinitosaber.com
          </a>
        </div>

        <div className="border-t border-white/10 pt-4 md:pt-6" data-id="element-127">
          <p className="text-[10px] md:text-xs text-white/60" data-id="element-128">
            © InfinitoSaber.com™ 2026 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}